import type { CountrySchema } from '@tectonics/prs/country';
import type { UserInputValidator } from '@tectonics/prs/validation';
import { buildGenericSchema } from './build-generic-schema';
import { buildOptionalFields } from './build-optional-fields';
import { toUserInputValidationError } from './to-user-input-validation-error';

export const buildValidator = (countrySchema: CountrySchema): UserInputValidator => ({
  spec, prsSupport, userInputName, userInputValue, userInputValues, incomingPayment,
}) => {
  const { onlyWhen, optionalFields } = buildOptionalFields({
    incomingPayment,
    userInputValues,
    spec,
    prsSupport,
  });

  const schema = buildGenericSchema({
    onlyWhen,
    optionalFields,
    countrySchema,
    incomingPayment,
  });

  const fieldSchema = schema.shape[userInputName];

  if (!fieldSchema) {
    return undefined;
  }

  const result = fieldSchema.safeParse(userInputValue);

  if (!result.success) {
    return toUserInputValidationError(result.error.issues[0]);
  }

  return null;
};
